<template>
  <div id='' class='gPageBorder' v-loading='loading'>

    <el-dialog class='gDia' :title="$t('app_push')" v-model="pushQs" @open=open @close='close'>
      <p>{{$t('app_ispushf') + '，' + fileName}}？</p>
      <span slot="footer" class="dialog-footer">
        <span style="margin-right:10px;" v-show="info.type === '1'">
          <el-checkbox v-model="check1">{{$t('app_autoscopen')}}</el-checkbox>
          <el-checkbox v-model="check2">{{$t('app_psscandtip')}}</el-checkbox>
        </span>
        <span style="margin-right:10px;" v-show="info.type === '2'">
          <el-checkbox v-model="check1">{{$t('app_tipud')}}</el-checkbox>
          <el-checkbox v-model="check2">{{$t('app_tipdown')}}</el-checkbox>
        </span>
        <el-button @click="pushQs = false">{{$t('app_cancel')}}</el-button>
        <el-button type="primary" @click="surePush">{{$t('app_srpush')}}</el-button>
      </span>
    </el-dialog>
   
    <el-dialog class='gDia' :title="$t('app_fipush') " v-model="pushImport" @close='closeImport'>
		  <el-form model="" rules="" ref="">
		    <el-form-item :label="$t('app_ulfile')" :label-width="formLabelWidth">

		      <el-upload
            class="upload-demo"
            ref="upload"
            name="fileUpload"
            :action="importTemplate"
            :on-remove="handleRemove"
            :before-upload="srcBefore"
            :on-success="srcSuccess"
            :on-error='ulError'
            :file-list="fileList"
            :auto-upload="true">
            <el-button slot="trigger" size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            <a :href="downTpl" style="margin-left:8px;margin-right:10px;"><el-button type="success" size='small'>{{$t('terminal.list.import_muban')}}</el-button></a>
          </el-upload>

		    </el-form-item>
		    <el-form-item :label="$t('app_deviceNum')" :label-width="formLabelWidth">
		      {{uldata?uldata.terNums : 0 + $t('app_amechine')}}
		    </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
        <span style="margin-right:10px;" v-show="info.type === '1'">
          <el-checkbox v-model="check1">{{$t('app_autoscopen')}}</el-checkbox>
          <el-checkbox v-model="check2">{{$t('app_psscandtip')}}</el-checkbox>
        </span>
        <span style="margin-right:10px;" v-show="info.type === '2'">
          <el-checkbox v-model="check1">{{$t('app_tipud')}}</el-checkbox>
          <el-checkbox v-model="check2">{{$t('app_tipdown')}}</el-checkbox>
        </span>
        <el-button @click="pushImport = false">{{$t('app_cancel')}}</el-button>
        <el-button :disabled="!uldata" style="margin-left: 10px;"  type="primary" @click="submitUpload">{{$t('app_srpush')}}</el-button>
      </span>
		</el-dialog>

    <el-dialog class='gDia' :title="$t('app_pushAll')" v-model="pushAll" @open=open @close='close'>
      <p>{{allMcName}}</p>
      <span slot="footer" class="dialog-footer">
        <span style="margin-right:10px;" v-show="info.type === '1'">
          <el-checkbox v-model="check1">{{$t('app_autoscopen')}}</el-checkbox>
          <el-checkbox v-model="check2">{{$t('app_psscandtip')}}</el-checkbox>
        </span>
        <span style="margin-right:10px;" v-show="info.type === '2'">
          <el-checkbox v-model="check1">{{$t('app_tipud')}}</el-checkbox>
          <el-checkbox v-model="check2">{{$t('app_tipdown')}}</el-checkbox>
        </span>
        <el-button @click="pushAll = false">{{$t('app_cancel')}}</el-button>
        <el-button type="primary" @click="surePushAll">{{$t('app_srpush')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog class='gDia' :title="$t('app_srpush')" v-model="pushAf" @open=open @close='close'>
      <p>{{surePushTip}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pushAf = false">{{$t('app_cancel')}}</el-button>
        <el-button @click="coverPush('1')">{{$t('app_cvpush')}}</el-button>
        <el-button type="primary" @click="coverPush('0')">{{$t('app_skpush')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog class='gDia' :title="$t('app_pssuccess')" v-model="pushDone" @open=open @close='close'>
      <p>{{$t('app_isjtoviewtd') + '?'}} </p> 
      <span slot="footer" class="dialog-footer">
        <el-button @click="pushDone = false">{{$t('app_cancel')}}</el-button>
        <el-button type="primary" @click="jumpNow">{{$t('app_nowjump')}}</el-button>
      </span>
    </el-dialog>
      


    <el-row>
      
      <el-col :span='12'>
        <el-button class='gSgLeftBtn' @click='multiBind' style=''>{{$t('app_mulPush')}} ({{sNum}})</el-button>
        <el-button  class='gSgLeftBtn' @click='pushAll = true;' style=''>{{$t('app_allpush')}}</el-button>
        <el-button :disabled="false" class='gSgLeftBtn' @click='pushImport = true' style=''>{{$t('app_fipush')}}</el-button>
      </el-col>
    

      <el-col :span='4'>
        <div class='gCtrl'>
          
          <!-- <el-select  @change='selectChange' style='' v-model="channelId" clearable :placeholder="$t('app_distributor')">
            <el-option
              v-for="item in channels"
              :key="item.mechanismid"
              :label="item.mechanismname"
              :value="item.mechanismid">
            </el-option>
          </el-select> -->
        
          <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
        </div>
      </el-col>

      <el-col :span='4'>
        <div class='gCtrl'><el-select  @change='selectStChange' style='' v-model="status" clearable :placeholder="$t('app_status')">
          <el-option
            v-for="item in stModel"
            :key="item.vl"
            :label="item.label"
            :value="item.vl">
          </el-option>
        </el-select></div>
      </el-col>

      <el-col :span='4'>
        <div class='gSideCtrl'><el-input :placeholder="$t('app_deviceNo')" v-model='iNo' @keyup.enter.native='srch' icon='search' :on-icon-click='srch'></el-input></div>
      </el-col>

    </el-row>
      
    <div id=''>
      <el-table
      class='gTopMg'
      ref="multipleTable"
      :data="tableData1"
      border
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange1">
        <el-table-column
          type="selection"
          align='center'
          width="80">
        </el-table-column>
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_deviceNo')"
          width="">
        </el-table-column>
        <el-table-column
          prop="terminalName"
          align='center'
          :label="$t('app_deviceName')"
          width="">
        </el-table-column>
        <el-table-column
          prop="terminal_status"
          align='center'
          :label="$t('app_status')"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 4 " type="danger" size="mini">{{$t('lin_btn.lock')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button  type='text' @click='bindOperate(scope.row)'>{{$t('app_push')}}</el-button> -->

            <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='bindOperate1(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class='gPgDiv'>

        <el-pagination
        class='gPg'
        @current-change="pageSelect1"
        @size-change="pageSized1"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1">
        </el-pagination>

      </div>
      
    </div>
  </div>
</template>

<style>
   #tbData{margin-top:20px;}
</style>

<script>
  import { baseurl,url,focusEvent,urlAssets } from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    data () {
      var that = this
      return {
        mechanismData: {
          callback (value, obj) {
            that.selectMcObj = obj
            that.channelId = value
            that.selectChange1(value)
          }
        },
        dvStatus: {
          "": this.$t('lin_global.all_status'),
          '1': this.$t('app_online'),
          "2": this.$t('app_offline'),
          "0": this.$t('app_new'),
          "3": this.$t('app_sleep'),
          "4": this.$t('lin_btn.lock')
        },
        uldata: '',
        fileList: [],
        isMarket: false,
        srcList: [],
        downTpl: `${urlAssets.prefix}tms-server-web/model/terminalNos.xlsx`,
        importTemplate: `${urlAssets.prefix}tms-server-web/import/terminalList.do`,
        formLabelWidth: '28.5%',
        selectMcObj: '',
        sNum: 0,
        resAf: '',
        check1: false,
        check2: false,
        pushQs: false,
        pushQsNo: '',
        pushAll: false,
        pushAf: false,
        pushDone: false,
        pushImport: false,
        status: '',
        iNo: '',
        row: this.$gRow,
        selected: [],
        info: '',
        launcherBind: '',
        tableData1: [],
        multipleSelection: [],
        channels: [],
        channelId: '',
        loading: 0,
        total1: 0,
        index: 1
      }
    },
    components: {MechanismSelector},
    computed: {
      fileName () {
        console.log('dddd',this.info)
        switch (this.info.type) {
          case '4':
            return this.info.data.firmwareName
            break
          case '10':
            
            break
          case '6':
           
            break
          case '2':
            return this.info.data.name
            break 
          case '1':
            return this.info.data.appName
            break
        }
        
      },
      surePushTip () {
        //return $t('app_ttpsddvnum') + pushAfNum + ', ' + $t('app_srsktsdv') + '?'
        return this.$t('app_psdonelftip').replace('{num}', this.pushAfNum)
      },
      pushAfNum () {
        return this.resAf? this.resAf.data.nums : ''
      },
      fileUploadUrl () {
        return `${baseurl}/terminal/importTers.do`+"?language="+localStorage.sys_lang + '&token=' + localStorage.user
//        return this.$fileExcelUlUrl
      },
      allMcName () {
        
        

        var mc = this.selectMcObj? this.selectMcObj.name : this.$t('lin_global.all_mechanism')
        var sp = "   ，"
        var str = this.$t('app_ispushalldv') + '？' + this.$t('app_distributor') + '：' + mc + sp + this.$t('app_status') + '：' + this.dvStatus[this.status] + sp + this.$t('app_deviceNum') + '：' + this.total1
       
        return str
      },
      stModel () {
        var app = [
          {label: this.$t('lin_global.all_status'), vl: ''},
          {label: this.$t('app_online'), vl: '1'},
          {label: this.$t('app_offline'), vl: '2'},
          {label: this.$t('app_new'), vl: '0'},
          {label: this.$t('app_sleep'), vl: '3'},
          {label: this.$t('lin_btn.lock'), vl: '4'}
        ]

        /*if (this.isLauncher) {
          app = [
            {label: this.$t('app_online'), vl: '1'},
            {label: this.$t('app_offline'), vl: '2'}
          ]
        }*/

        return app
      },
      isLauncher () {
        if (this.launcherBind) {
          return true
        } else {
          return false
        }
      }
      /* index () {
        var vl = this.$getWPage('appMarketTerPage')
        // console.log('page', vl)
        return vl
      } */
    },
    methods: {
      surePush () {
        //this.bindOperate()
        //console.log(this.pushQsNo)
        this.pushQs = false
        this.bindRqs('0', this.pushQsNo, this.check2, this.check1)
      },
      closeImport () {
        this.fileList = []
        this.uldata = ''
      },
      handleRemove () {

      },
      ulError () {
        window[this.$route.path] = ''
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        //console.log(res, this.fileList)
        
        if (res.status === 200) {
          this.fileList = [{name: file.name}]
          this.uldata = res.data
        } else {
         
          this.srcList = []
          
          this.$message.error(res.message)
        }
      },
      srcBefore (file) {
        window[this.$route.path] = 1
      },
      submitUpload () {
        //console.log(this.uldata)
        this.bindRqs('2')
        this.pushImport = false
      },
      jumpNow () {
        this.$router.push({path: '/task/ptask'})
      },
      skipPush () {

      },
      surePushAll () {
        this.bindRqs('1', '') 
        //this.pushAll = false
      },
      surePushAf () {
        this.bindRqs('1', '') 
        //this.pushAll = false
      },
      coverPush (cvParam) {
        //console.log(this.resAf)
        
        this.loading = 1
        this.$isCoverPush(this.resAf.data.taskId, this.resAf.data.pushParam, cvParam, (res) => {    
          this.loading = 0
          if (res.status === 200) {
            this.pushAf = false
            this.pushDone = true
          } else {
            this.$message.error(res.message)
          }
        }, (error) => {
          this.loading = 0
          this.$message.error(this.$('app_rqsError'))
        }) 
      },
      pageSelect1 (index) {
        this.index = index
       
          this.getDevices()
        
        // this.$setWPage('appMarketTerPage', index)
      },
      pageSized1 (val) {
        this.$gRow = val
       
        this.getDevices()
        
      },
      selectChange1 (vl) {
        
          this.getDevices()
        
      },
      selectStChange (vl) {
        
          this.getDevices()
        
      },
      srch () {
       
          this.getDevices()
        
      },
      handleSelectionChange1 (list) {
        this.sNum = list.length
        this.selected = list
      },
      multiBind () {
        // terminal_id
        // console.log(this.selected)
        var ids = ''
        var tNo = ''
        var tmid = ''
        this.selected.forEach((vl) => {
          ids += vl.terminalId + ','
          tNo += vl.terminalNo + ','
          tmid += vl.manufId + ','
        })
        ids = ids.substring(0, ids.length - 1)
        tNo = tNo.substring(0, tNo.length - 1)
        tmid = tmid.substring(0, tmid.length - 1)
        
        
        if (!tNo) {
          this.$message(this.$t('app_oneDeviceMust'))
          return
        }
        //console.log(tNo)
        if (this.info.type === '1' || this.info.type === '2') {
          this.pushQs = true
          this.pushQsNo = tNo
        } else {
          this.bindRqs('0', tNo)
        }
        
      },
      bindRqs (pushType, tNos) {
        
        this.loading = 1
        var terNos = ''
        var mecId = ''
        var terStatus = ''
        var terNo = ''
        var flNo = ''
        var objId = ''
        var auto = this.check1 ? '1':'0'
        var install = this.check2 ? '1':'0'
        switch (pushType) {
          case '0':
            terNos = tNos
            break
          case '1':
            mecId = this.channelId ? this.channelId : ''
            terStatus = this.status ? this.status : ''
            terNo = this.iNo ? this.iNo : ''
            break
          case '2':
            flNo = this.uldata ? this.uldata.fileNo : ''
            break
        }

        switch (this.info.type) {
          case '4':
          case '2':
            objId = this.info.data.id
            break
          case '10':
            objId = this.info.data.launcherid
            break
          case '6':
            objId = this.info.data.animatId
            break
          case '1':
            if (this.isMarket) {
              objId = this.info.data.applicationid
            } else {
              objId = this.info.data.appdevid
            }
            
            break
        
        }
        
        this.$addPush(install, auto, objId, this.info.type, pushType, terNos, mecId, terStatus, terNo, flNo, (res) => {
          console.log('pushRqs', res)
          this.loading = 0
          this.check1 = false
          this.check2 = false
          if (res.status === 200) {
            this.pushAll = false
            //this.$message.success(this.$t('app_tipViewTask'))
            this.getDevices()
            this.pushDone = true
          } else if (res.status === 300) {
            this.pushAll = false
            this.pushAf = true
            this.resAf = res
          } else {
            this.$message.error(res.message)
          }
        }, (error) => {
          this.loading = 0
          this.$message.error(this.$('app_rqsError'))
        }) 
      },
      bindOperate1 (row) {
        
        if (this.info.type === '1' || this.info.type === '2') {
          this.pushQs = true
          this.pushQsNo = row.terminalNo
          //this.bindRqs('0', row.terminalNo, this.check1, this.check2)
        } else {
          
          this.bindRqs('0', row.terminalNo)
        }
        //console.log(row, this.info.data)
      },
      getChannels () {
        this.$getChannelList(10000, 1, '', '', '', (res) => {
          if (res.status === 200) {
            this.channels = res.data
            // console.log(this.channels)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getDevices () {
        var channel = this.channelId ? this.channelId : ''
        var terminalNo = this.iNo ? this.iNo : ''
        var status = this.status ? this.status : ''
        //var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid


        var mFileId,fileId,fileType

    
        
        switch (this.info.type) {
          case '4':
            mFileId = this.info.data.mechanismId
            fileId = this.info.data.id
            fileType = ''
            break
          case '10':
            mFileId = this.info.data.distrabutorid
            fileId = this.info.data.launcherid
            fileType = '10'
            break
          case '6':
            mFileId = ''
            fileId = this.info.data.animatId
            fileType = ''
            break
          case '2':
            mFileId = this.info.data.mechanismId
            fileId = this.info.data.id
            fileType = ''
            break 
          case '1':
            //mFileId = this.info.data.distributorId
            mFileId = ''
            //fileId = this.info.data.applicationid
            if (this.isMarket) {
              fileId = this.info.data.applicationid
            } else {
              fileId = this.info.data.appdevid
            }
            fileType = '1'
            break
        }
        
        this.loading = 1
        this.$canPushTer(this.index, this.$gRow, mFileId, channel, status, terminalNo, fileType, fileId, (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.data) {
            this.total1 = res.total
            this.tableData1 = res.data
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
     
      bind (tId, tNo, tmid) {
        // console.log(this.info)
        var vl = tId ? tId : ''
        this.loading = 1

        var cId = this.info.appdevid ? this.info.appdevid : this.info.applicationid

        if (this.$appUrlTag === 0) {
          this.$bindApp('0', vl, cId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          this.$bindApp1(tmid, tNo, cId, (res) => {
            if (res.status === 200) {
              this.$message.success(this.$t('app_tipViewTask'))
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      }
    },
    mounted () {alert('test')

      this.isMarket = this.$route.path === '/appSlot/terminal-bind'
      //var isLauncher = this.$route.path === '/launch-push/launch-push-ter'
      var obj = this.$getWObj().pushList
      this.info = obj
      console.log(obj)


      this.getDevices()
     
    }
  }
</script>



// WEBPACK FOOTER //
// PushBindCm.vue?59169328